import React, { useState, useEffect } from "react";
import { Card, CardHeader, Icon } from "@ui5/webcomponents-react";
import { PieChart } from "@ui5/webcomponents-react-charts";
import "@ui5/webcomponents-icons/dist/AllIcons.js";

const InvoiceStatusDistributionCard = ({ invoiceData }) => {
  const [statusDistribution, setStatusDistribution] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const [pendingReviewCount, setPendingReviewCount] = useState(0);

  useEffect(() => {
    const calculateStatusDistribution = () => {
      if (!invoiceData || invoiceData.length === 0) {
        setStatusDistribution([]);
        setLoading(false);
        setTotalInvoices(0);
        setPendingReviewCount(0);
        return;
      }

      const distribution = {};
      let pendingReview = 0;

      invoiceData.forEach((invoice) => {
        const status = invoice.status;
        distribution[status] = (distribution[status] || 0) + 1;
        if (status === "Pending") {
          pendingReview++;
        }
      });

      const statusDistributionArray = Object.entries(distribution).map(([status, count]) => ({
        name: status,
        users: count
      }));

      setStatusDistribution(statusDistributionArray);
      setTotalInvoices(invoiceData.length);
      setPendingReviewCount(pendingReview);
      setLoading(false);
    };

    calculateStatusDistribution();
  }, [invoiceData]);

  const statusText = `${pendingReviewCount} Pending Review`;



  return (
    <Card
      header={<CardHeader avatar={<Icon name="documents" />} status={statusText} subtitleText="Status Distribution" titleText="Scanned Invoices"/>}
      style={{
        marginBottom: "20px"
      }}
    >
      <PieChart
        dataset={statusDistribution}
        dimension={{
          accessor: 'name'
        }}
        measure={{
          accessor: 'users',
		  colors: [
      '#035663',
      '#0070FF'
    ]
        }}
        onClick={() => {}}
        onDataPointClick={() => {}}
        onLegendClick={() => {}}
      />
    </Card>
  );
};

export default InvoiceStatusDistributionCard;

